import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { errorFragment } from "../../../../../gql/GqlErrorFragment";
import {
  CreateHeadAgreementInput,
  CreateHeadAgreementMutation,
  CreateHeadAgreementMutationVariables,
} from "@/gql/graphql";
import { customerDetailsQuery } from "@/features/product-and-price/customers/customer-details/hooks/useCustomerDetails";

const mutation = gql`
  ${errorFragment}
  mutation CreateHeadAgreement($input: CreateHeadAgreementInput!) {
    productPrice {
      headAgreement {
        createHeadAgreement(input: $input) {
          ... on CreateHeadAgreementSuccessResult {
            customer {
              id
            }
            headAgreement {
              id
            }
          }
          ... on ErrorResult {
            ...ErrorFragment
          }
        }
      }
    }
  }
`;

export const useCreateHeadAgreementMutation = () => {
  const [mutate, { error, loading }] = useMutation<
    CreateHeadAgreementMutation,
    CreateHeadAgreementMutationVariables
  >(mutation, {
    update(cache, { data }) {
      const result = data?.productPrice.headAgreement.createHeadAgreement;
      if (result?.__typename === "CreateHeadAgreementSuccessResult") {
        const customerId = result?.customer.id;
        if (customerId) {
          cache.evict({
            id: cache.identify({ __typename: "Customer", id: customerId }),
          });
          cache.gc();
        }
      }
    },
  });

  const createHeadAgreement = useCallback(
    (input: CreateHeadAgreementInput) => {
      return mutate({ variables: { input } });
    },
    [mutate]
  );

  return {
    createHeadAgreement,
    error,
    loading,
  };
};
